import React from 'react';
import Tab from 'react-bootstrap/Tab';
import MessagingConfiguration from '../Messaging/MessagingConfiguration';
import MockServiceTransactionShuttle from '../../MockServiceTransactionShuttle';
import { Tabs } from 'react-bootstrap';
import { MessagingProtocol, MockService } from 'types/rest/mockServiceTypes';
import { useTranslation } from 'react-i18next';
import { runnerContentTabStyles } from './HttpRunnerTabs';
import _ from 'lodash';
import { MockParameterState } from '../../MockParameters';
import { mockServicePatchAction } from 'store/mockServices/mockServiceList/mockServiceListActions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store/rootReducer';
import { updateMessagingRunnerTab } from 'store/mockServices/mockServiceDetail/mockServiceDetailActions';
import MessagingRecordingConfiguration from '../Messaging/Recordings/MessagingRecordingConfiguration';
import { isTemplate } from 'utils/miscUtil';
import { updateTemplateMessagingRunnerTab } from 'store/mockServiceTemplates/mockServiceTemplateDetail/mockServiceTemplateDetailActions';
import TemplatesTransactionShuttle from '../../../MockTemplates/TemplatesTransactionShuttle';
import { updateMockServiceTemplate } from 'store/mockServiceTemplates/mockServiceTemplatesActions';
import MsRecordingsShuttleWrapper from '../Messaging/Shuttle/MsRecordingsShuttleWrapper';
import TemplateRecordingsShuttle from '../../../MockTemplates/TemplateRecordingsShuttle';

interface Props {
  mockService: MockService;
  disabled: boolean;
}

const MessagingRunnerTabs = ({ mockService, disabled }: Props) => {
  const { t } = useTranslation('mockServices');
  const { isRecorderModeActive } = mockService;
  const activeTab = useSelector((state: ApplicationState) => {
    return !isTemplate(mockService)
      ? state.mockServiceDetails.messagingRunnerTab
      : state.mockServiceTemplateDetail.messagingRunnerTab;
  });
  const dispatch = useDispatch();

  const updateParametersDebounced = _.debounce((params: MockParameterState) => {
    updateParameters(params);
  }, 600);

  const updateParameters = (params: MockParameterState) => {
    const ms = Object.assign({}, mockService, params);
    if (!isTemplate(mockService)) {
      dispatch(mockServicePatchAction(ms));
    } else {
      dispatch(updateMockServiceTemplate(ms));
    }
  };

  return (
    <div>
      <Tabs
        transition={false}
        id="http-runner-tabs"
        activeKey={activeTab}
        onSelect={tab => {
          if (!isTemplate(mockService)) {
            dispatch(updateMessagingRunnerTab(tab));
          } else {
            dispatch(updateTemplateMessagingRunnerTab(tab));
          }
        }}
        className={'mb-0'}
        mountOnEnter={true}
      >
        <Tab className={runnerContentTabStyles} key={'main'} eventKey="main" title={'Broker Configuration'}>
          <MessagingConfiguration
            mockService={mockService}
            onUpdate={(updatedMock, debounced) => {
              if (debounced) {
                updateParametersDebounced(updatedMock);
              } else {
                updateParameters(updatedMock);
              }
            }}
            disabled={disabled}
          />
        </Tab>
        {!isRecorderModeActive && (
          <Tab
            className={runnerContentTabStyles}
            key={'transactions'}
            eventKey="transactions"
            title={t('mockServiceDetails.transactions')}
          >
            {isTemplate(mockService) ? (
              <TemplatesTransactionShuttle
                disabled={disabled}
                template={mockService}
                transactionType={'MESSAGING'}
                key={'messaging-transactions-templates'}
              />
            ) : (
              <MockServiceTransactionShuttle
                mockService={mockService}
                disabled={disabled}
                transactionType={'MESSAGING'}
                key={'messaging-transactions'}
              />
            )}
          </Tab>
        )}
        {!isRecorderModeActive && (
          <Tab className={runnerContentTabStyles} key={'recordings'} eventKey="recordings" title={'Recordings'}>
            {!isTemplate(mockService) ? (
              <MsRecordingsShuttleWrapper disabled={disabled} mockService={mockService} />
            ) : (
              <TemplateRecordingsShuttle disabled={disabled} template={mockService} />
            )}
          </Tab>
        )}
        {isRecorderModeActive && (
          <Tab
            className={runnerContentTabStyles}
            key={'recordingConfig'}
            eventKey="recordingConfig"
            title={'Recording Configuration'}
          >
            <MessagingRecordingConfiguration
              disabled={disabled}
              mockService={mockService}
              onUpdate={updateParameters}
            />
          </Tab>
        )}
      </Tabs>
    </div>
  );
};

export default MessagingRunnerTabs;
